require('../modules/es7.array.includes');
require('../modules/es7.array.flat-map');
require('../modules/es7.array.flatten');
module.exports = require('../modules/_core').Array;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/es7/array.js
 ** module id = 341
 ** module chunks = 0 1
 **/